const timestampToDDMM = (timestamp) => {
    const date = new Date(timestamp * 1000);
    const options = { day: '2-digit', month: '2-digit' };
    const formattedDate = date.toLocaleString('vi-VN', options).replace(/-/g, '/'); // Định dạng ban đầu là dd-mm. Dùng replace đổi thành dd/mm
    return formattedDate;
}

export default timestampToDDMM;